const linkLandingPagesIT = {
    "view": {
        "table": {
            "title": "Le tue pagine di destinazione del link",
            "column": {
                "title": "Titolo",
                "description": "Descrizione",
                "backUrl": "URL di ritorno",
                "created": "Creato",
                "landingPage": "Pagina di destinazione",
                "action": "Azione"
            },
            "label": {
                "landingPage": "Pagina di destinazione"
            },
            "button": {
                "view": "Visualizza",
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "message": {
                "linkCopied": "Link copiato negli appunti!"
            }
        },
        "modal": {
            "edit": {
                "header": "Modificare {{linkLandingPageName}}?",
                "body": "Sei sicuro di voler modificare questa pagina di destinazione del link?"
            },
            "delete": {
                "header": "Eliminare {{linkLandingPageName}}?",
                "body": "Sei sicuro di voler eliminare questa pagina di destinazione del link?"
            }
        },
        "message": {
            "success": "La pagina di destinazione del link è stata rimossa!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!",
            "llpAllowanceSpent": "Hai esaurito la tua quota di pagine di destinazione del link. Per creare più pagine di destinazione del link, aggiorna il tuo account o contatta il nostro team di supporto.",
            "subscriptionFeatureUnavailable": "Il tuo attuale piano di abbonamento non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "add": {
        "title": "Aggiungi Pagina di Destinazione del Link",
        "form": {
            "label": {
                "domain": "Dominio",
                "title": "Titolo",
                "backUrl": "URL di ritorno",
                "shortDescription": "Breve Descrizione",
                "logo": "Logo",
                "backgroundImage": "Immagine di Sfondo",
                "blurredBackground": "Sfondo Sfocato",
                "blurred": "Sfocato",
                "notBlurred": "Non Sfocato",
                "blurStrength": "Intensità Sfocatura",
                "layout": "Layout",
                "font": "Carattere",
                "socialIconPlacement": "Posizionamento Icona Sociale",
                "socialIconColor": "Colore Icona Sociale",
                "buttonCorners": "Angoli del Pulsante",
                "buttonStyle": "Stile del Pulsante",
                "colorCustomisation": "Personalizzazione Colore",
                "premadeColors": "Colori Predefiniti",
                "customColors": "Colori Personalizzati",
                "headerBackground": "Sfondo Intestazione",
                "singleColor": "Colore Unico",
                "gradient": "Gradiente",
                "bodyBackground": "Sfondo Corpo",
                "titleColor": "Colore Titolo",
                "descriptionColor": "Colore Descrizione",
                "buttonColor": "Colore Pulsante",
                "buttonTextColor": "Colore Testo Pulsante",
                "backgroundColor": "Colore di Sfondo"
            },
            "placeholder": {
                "domain": "Seleziona Dominio",
                "shortDescription": "Alcune parole sulla tua pagina di destinazione. Max 80 caratteri"
            },
            "help_text": {
                "domain": "Seleziona il dominio per cui vuoi creare la Pagina di Destinazione del Link.",
                "logo": "Carica formati JPG o PNG, risoluzione almeno 500x500 px",
                "backgroundImage": "Carica formati JPG o PNG, risoluzione di 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout Uno",
                    "layoutTwo": "Layout Due"
                },
                "socialIconPlacement": {
                    "header": "Intestazione",
                    "bottomOfTheBody": "Fondo del Corpo"
                },
                "socialIconColor": {
                    "color": "Colore",
                    "black": "Nero",
                    "white": "Bianco"
                },
                "buttonCorners": {
                    "rounded": "Arrotondati",
                    "semiRounded": "Semi Arrotondati",
                    "squared": "Squadrati"
                },
                "buttonStyle": {
                    "outlined": "Contornato",
                    "filled": "Pieno"
                }
            },
            "button": {
                "submit": "Invia"
            },
            "validation": {
                "formInvalid": "Il modulo non può essere inviato! Si prega di compilare tutti i campi e controllare gli errori!",
                "storeUrlRequired": "L'URL di {{store}} è richiesto",
                "storeUrlValid": "Si prega di aggiungere un URL valido di {{store}}."
            }
        },
        "message": {
            "success": "La Pagina di Destinazione del Link è stata aggiunta!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
        },
        "modal": {
            "add": {
                "header": "Aggiungere Pagina di Destinazione {{title}}?",
                "body": "Sei sicuro di voler creare la Pagina di Destinazione del Link con il titolo {{title}}?"
            }
        }
    },
    "update": {
        "title": "Aggiorna Pagina di Destinazione del Link",
        "form": {
            "label": {
                "domain": "Dominio",
                "title": "Titolo",
                "backUrl": "URL di ritorno",
                "shortDescription": "Breve Descrizione",
                "logo": "Logo",
                "backgroundImage": "Immagine di Sfondo",
                "blurredBackground": "Sfondo Sfocato",
                "blurred": "Sfocato",
                "notBlurred": "Non Sfocato",
                "blurStrength": "Intensità Sfocatura",
                "layout": "Layout",
                "font": "Carattere",
                "socialIconPlacement": "Posizionamento Icona Sociale",
                "socialIconColor": "Colore Icona Sociale",
                "buttonCorners": "Angoli del Pulsante",
                "buttonStyle": "Stile del Pulsante",
                "colorCustomisation": "Personalizzazione Colore",
                "premadeColors": "Colori Predefiniti",
                "customColors": "Colori Personalizzati",
                "headerBackground": "Sfondo Intestazione",
                "singleColor": "Colore Unico",
                "gradient": "Gradiente",
                "bodyBackground": "Sfondo Corpo",
                "titleColor": "Colore Titolo",
                "descriptionColor": "Colore Descrizione",
                "buttonColor": "Colore Pulsante",
                "buttonTextColor": "Colore Testo Pulsante",
                "backgroundColor": "Colore di Sfondo"
            },
            "placeholder": {
                "domain": "Seleziona Dominio",
                "shortDescription": "Alcune parole sulla tua pagina di destinazione. Max 80 caratteri"
            },
            "help_text": {
                "domain": "Seleziona il dominio per cui vuoi creare la Pagina di Destinazione del Link.",
                "logo": "Carica formati JPG o PNG, risoluzione almeno 500x500 px",
                "backgroundImage": "Carica formati JPG o PNG, risoluzione di 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout Uno",
                    "layoutTwo": "Layout Due"
                },
                "socialIconPlacement": {
                    "header": "Intestazione",
                    "bottomOfTheBody": "Fondo del Corpo"
                },
                "socialIconColor": {
                    "color": "Colore",
                    "black": "Nero",
                    "white": "Bianco"
                },
                "buttonCorners": {
                    "rounded": "Arrotondati",
                    "semiRounded": "Semi Arrotondati",
                    "squared": "Squadrati"
                },
                "buttonStyle": {
                    "outlined": "Contornato",
                    "filled": "Pieno"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Altro"
                }
            },
            "button": {
                "submit": "Invia"
            }
        },
        "message": {
            "success": "La Pagina di Destinazione del Link è stata aggiornata!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
        },
        "modal": {
            "update": {
                "header": "Aggiornare Pagina di Destinazione {{title}}?",
                "body": "Sei sicuro di voler aggiornare la Pagina di Destinazione del Link con il titolo {{title}}?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Link Sociali",
        "label": {
            "order": "Ordine",
            "platform": "Piattaforma",
            "destinationUrl": "URL di Destinazione"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Altro"
            }
        },
        "button": {
            "remove": "Rimuovi",
            "add": "Aggiungi un Altro"
        }
    },
    "featuredLinksRow": {
        "title": "Link in Evidenza",
        "label": {
            "order": "Ordine",
            "label": "Etichetta",
            "destinationUrl": "URL di Destinazione"
        },
        "button": {
            "remove": "Rimuovi",
            "add": "Aggiungi un Altro"
        }
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Recupero Analisi per Music Link"
        },
        "button": {
            "last7Days": "Ultimi 7 Giorni",
            "last14Days": "Ultimi 14 Giorni",
            "last30Days": "Ultimi 30 Giorni"
        },
        "linkLandingPageViews": {
            "title": "Visualizzazioni Pagina di Destinazione del Link",
            "subtitle": "Visualizzazioni Totali",
            "label": {
                "views": "Visualizzazioni"
            }
        },
        "socialLinkClicks": {
            "title": "Clic sui Link Sociali",
            "subtitle": "Clic Totali",
            "table": {
                "column": {
                    "platform": "Piattaforma",
                    "destinationUrl": "URL di Destinazione",
                    "clicks": "Clic",
                    "clicksPct": "Clic (%)"
                }
            }
        },
        "featuredLinkClicks": {
            "title": "Clic sui Link in Evidenza",
            "subtitle": "Clic Totali",
            "table": {
                "column": {
                    "label": "Etichetta",
                    "destinationUrl": "URL di Destinazione",
                    "clicks": "Clic",
                    "clicksPct": "Clic (%)"
                }
            }
        },
        "topTerritories": {
            "title": "Territori Principali",
            "subtitle": "Visualizzazioni Totali",
            "table": {
                "column": {
                    "territory": "Territorio",
                    "views": "Visualizzazioni",
                    "viewsPct": "Visualizzazioni (%)"
                },
                "label": {
                    "otherTerritories": "Altri Territori"
                }
            }
        },
        "topBrowsers": {
            "title": "Browser Principali",
            "subtitle": "Visualizzazioni Totali",
            "table": {
                "column": {
                    "browser": "Browser",
                    "views": "Visualizzazioni",
                    "viewsPct": "Visualizzazioni (%)"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Tipi di Dispositivi Principali",
            "table": {
                "column": {}
            }
        },
        "topOperatingSystems": {
            "title": "Sistemi Operativi Principali",
            "label": {
                "os": "Sistema Operativo",
                "views": "Visualizzazioni"
            }
        }
    }
};

export default linkLandingPagesIT;